/**
 * zhanghengh
 * 18/5/31
 * 公式编辑器的表和数据部分，用的包装后的钉耙的组件，如有问题，可以参考钉耙的的例子
 * 后端是汪建伟
 */
import React, { Component } from 'react';
import {
    Button,
    Row,
    Col,
    Checkbox,
    Input,
    DragWidthCom,
} from '@platform/base';

import { ajax, toast, isString, getMultiLang, microAppUtil } from '@platform/api';
import VirtualizedDatabase from './VirtualizedDatabase';
require('./surface.less');
export default class Surface extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false, //控制checkbox的状态
            surfaceData: [], //表的数据
            surfaceCount: 0, // 匹配到的数据库表数量
            cacheData: [], // 表的缓存数据
            fieldData: [], //字段的数据
            inputValue: '', // input 的值
            json: {},
        };
        this.appBody = microAppUtil.getDocument();
    }

    componentWillMount() {
        const { surfaceUrl } = this.props;
        // 初始化调用getPlatformLang方法获取多语
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'container_formulaEditor', callback }); // moduleId为所需加载json文件夹名称前缀
        ajax({
            //初始加载数据
            url: isString(surfaceUrl) ? surfaceUrl : '/nccloud/formula/web/formulatab.do',
            loading: false,
            success: res => {
                this.setState({
                    surfaceData: res.data, //当前数据
                    cacheData: res.data, //初始数据
                });
            },
            error: e => {
                toast({ color: 'danger', content: e.message });
            },
        });
    }

    // componentWillReceiveProps(nextProps) {  //暂时注释不要删除，可能会有用
    //   const { surfaceUrl } = nextProps;  //最新的props
    //   const { surfaceUrl: oldSurfaceUrl } = this.props;  //上一次的props
    //   if(surfaceUrl !== oldSurfaceUrl) {  //当传入的路径变化时才重新请求，做到优化作用
    //     ajax({
    //       url: isString(surfaceUrl) ? surfaceUrl : '/nccloud/formula/web/formulatab.do',
    //       loading: false,
    //       success: (res) => {
    //         this.setState({
    //           surfaceData: res.data,//当前数据
    //           cacheData: res.data//初始数据
    //         });
    //       },
    //       error: (e) => {
    //         toast({ color: 'danger', content: e.message });
    //       }
    //     });
    //   }
    // }

    /**
     * zhanghengh
     * 18/5/30
     * input变化回调
     */
    handleInput = value => {
        const { surfaceData, cacheData } = this.state;
        if (cacheData) {
            const newData = cacheData.filter(eve => {
                const displayName = eve.displayName.toLowerCase();
                const searchValue = value.toLowerCase();
                if (displayName.search(searchValue) > -1) {
                    return true;
                }
            });
            this.setState(
                {
                    surfaceData: newData,
                    surfaceCount: newData.length,
                    inputValue: value,
                },
                () => {
                    if (newData.length > 0) {
                        this._getFieldData(newData[0].displayName);
                    } else {
                        this.setState({ fieldData: [] });
                    }
                },
            );
        }
    };

    /**
     * zhanghengh
     * 18/5/30
     * 创建表字段内容
     */
    _createContent(data) {
        return data.map((eve, index) => {
            const { displayName, inputSig, hintMsg } = eve;
            return (
                <li key={index} data-name={inputSig} data-explain={hintMsg} data-title={displayName} onDoubleClick={this.handleDbList}>
                    {displayName}
                </li>
            );
        });
    }
    /**
    * 创建数据库表内容
    */
    _renderDataBaseItem=( eve, k ) => {
        let { inputValue } = this.state;
        const { displayName, inputSig, hintMsg } = eve;
        const _index = displayName.toLowerCase().search(inputValue.toLowerCase());
        const beforeStr = displayName.substr(0, _index);
        const inputStr = displayName.substr(_index, inputValue.length);
        const afterStr = displayName.substr(_index + inputValue.length);
        const title = (
            <span>
                {beforeStr}
                <span style={{ color: '#f53c32' }}>
                    {inputStr}
                </span>
                {afterStr}
            </span>
        );
        return (
            <li style={{ height: this.rowHeight }} data-index={'item' + k} key={k} data-name={inputSig} data-explain={hintMsg} data-title={displayName} onDoubleClick={this.handleDbList} onClick={this.handleSurfaceList}>
                {_index > -1 ? title : displayName}
            </li>
        );

    }
    _createDatabaseContent(data) {
        return (
            data.length ? 
                <VirtualizedDatabase 
                    data={data} 
                    renderItem={this._renderDataBaseItem} 
                    itemHeight={24}
                    wrapperClassName = 'surface-content-box surface-left-ul'
                /> : 
                null
        );

        // return data.map((eve, k) => {
        //     const { inputValue } = this.state;
        //     const { displayName, inputSig, hintMsg } = eve;

        //     const _index = displayName.toLowerCase().search(inputValue.toLowerCase());
        //     const beforeStr = displayName.substr(0, _index);
        //     const inputStr = displayName.substr(_index, inputValue.length);
        //     const afterStr = displayName.substr(_index + inputValue.length);
        //     const title = (
        //         <span>
        //             {beforeStr}
        //             <span style={{ color: '#f53c32' }}>
        //                 {inputStr}
        //             </span>
        //             {afterStr}
        //         </span>
        //     );
        //     // console.log(_index, beforeStr,inputStr, afterStr)
        //     return (
        //         <li key={k} data-name={inputSig} data-explain={hintMsg} data-title={displayName} onDoubleClick={this.handleDbList} onClick={this.handleSurfaceList}>
        //             {_index > -1 ? title : displayName}
        //         </li>
        //     );
        // });
    }

    /**
     * 获取字段的数据
     * zhanghengh
     */
    _getFieldData = title => {
        let json = this.state.json;
        ajax({
            url: '/nccloud/formula/web/formulatabfield.do',
            loading: false,
            data: { tablename: title },
            success: res => {
                this.setState({ fieldData: res.data });
            },
            error: () => {
                toast({ color: 'danger', content: `${json['formula0011']}` });
            },
        });
    };

    /**
     * 清空其他选中节点的样式
     */
    clearCheckedClassname = name => {
        let checkedList = this.appBody.querySelectorAll(`.${name}`);
        checkedList.length && checkedList.forEach(v=> v?.classList.remove(name));
    }
    /**
     * zhanghengh
     * 18/5/30
     * 单击表格列表的回调
     */
    handleSurfaceList = e => {
        const { surfaceData } = this.state;
        const { setExplain } = this.props;
        const { explain, title } = e.currentTarget.dataset;
        const name = "surface-data-active";
        const fieldName = "surface-field-active";
        if (surfaceData.length && title) {
            setExplain(explain);
            this.clearCheckedClassname(name);
            this.clearCheckedClassname(fieldName);
            e.currentTarget?.classList.add(name);
            this._getFieldData(title);
        }
    };

    /**
     * zhanghengh
     * 18/5/30
     * 单击字段列表的回调
     */
    handleFieldList = e => {
        const name = "surface-field-active";
        this.clearCheckedClassname(name);
        e.target?.classList.add(name);
        this.props.setExplain(e.target.dataset.explain);
    };

    /**
     * zhanghengh
     * 18/5/30
     * 双击列表的回调
     */
    handleDbList = e => {
        const { surfaceData } = this.state;
        if (surfaceData.length) {
            const { name } = e.currentTarget.dataset;
            this.props.setName(name);
        }
    };
    /**
     * 创建数据库表
     */
    createDatabaseArea = () => {
        const { surfaceData, json } = this.state;
        return (
            <div className="surface-left-content">
                <div className="surface-title-box">
                    <span className="surface-title">{json['formula0018']}</span>
                </div>
                {/* <ul className="surface-content-box surface-left-ul">
                    {this._createDatabaseContent(surfaceData)}
                </ul> */}
                {this._createDatabaseContent(surfaceData)}
            </div>
        );
    }
    /**
     * 创建表字段
     */
    createFieldArea = () => {
        const { fieldData, json } = this.state;
        return (
            <div className="surface-right-content">
                <div className="surface-title-box">
                    <span className="surface-title">{json['formula0019']}</span>
                </div>
                <ul className="surface-content-box surface-right-ul" onClick={this.handleFieldList}>
                    {this._createContent(fieldData)}
                </ul>
            </div>
        );
    }
    /**
     * zhanghengh
     * 18/5/30
     * 创建内容
     */
    _createAll = () => {
        const { inputValue, json, surfaceCount } = this.state;
        // console.log(inputValue, surfaceCount)
        return (
            <div className="surface-area">
                <span className="filter-num">{!!inputValue&&!!surfaceCount&&surfaceCount}</span>
                <Input
                    value={inputValue}
                    type="search"
                    style={{
                        width: '100%'
                    }}
                    placeholder={json['formula0021']}
                    onChange={this.handleInput}
                />
                <DragWidthCom
                    leftDom={this.createDatabaseArea()}
                    rightDom={this.createFieldArea()}
                />

            </div>
        );
    };

    render() {
        return this._createAll();
    }
}
